import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServerErrorInterceptor } from './error-handler.service';
import { RouterModule } from '@angular/router';
import { routes } from './routes';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ErrorPageBaseComponent } from './error-page-base/error-page-base.component';
import { ServerMaintenancePageComponent } from './server-maintenance-page/server-maintenance-page.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [PageNotFoundComponent, ErrorPageBaseComponent, ServerMaintenancePageComponent],
  imports: [CommonModule, TranslateModule, RouterModule.forChild(routes)],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true }],
})
export class ErrorHandlingModule {}
